import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
// import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)
import MacroIframe from './MacroIframe/MacroIframe.vue'

Vue.customElement('v-iframe', MacroIframe)

